/* eslint-disable react/jsx-handler-names */
import {PropTypes} from 'prop-types';
import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import SettingService from '../services/SettingService';
import DivContainer from './DivContainer';
import InputDropdownComponent from './inputs/InputDropdownComponent';
import InputTextComponent from './inputs/InputTextComponent';

class PhoneNumberComponent extends Component {
    constructor(props) {
        super(props);
        this.settingService = new SettingService();
        this.state = {
            selectedCode: undefined,
            telephoneCodeOptions: [],
        };
        this._isMounted = false;
    }

    componentDidMount() {
        this._isMounted = true;
        if (this.props.rendered) {
            this.settingService
                .getTelephoneCodeList()
                .then((telephoneCodeOptions) => {
                    if (this._isMounted) {
                        this.setState({
                            telephoneCodeOptions: telephoneCodeOptions,
                        });
                    }
                })
                .catch(() => {});
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        const {
            colClass,
            disabled,
            filter,
            id,
            insideTable,
            labelCode,
            labelPhoneNumber,
            nameCode,
            namePhoneNumber,
            onAfterStateChange,
            onChange,
            telephoneCodeOptions,
            placeholder,
            publicMode,
            showClear,
            showLabel,
            stateField,
            validator,
            phoneCodeValue,
            phoneNumberValue,
            viewMode,
            rendered,
            renderRequired,
            required,
            validateViewMode,
            inputTextColClass,
        } = this.props;
        if (rendered) {
            return (
                <DivContainer colClass={insideTable ? 'col-12' : colClass}>
                    <DivContainer colClass='row phone-number-row'>
                        <InputDropdownComponent
                            colClass='col-6 phone-nr-input-style'
                            dataKey={'code'}
                            disabled={disabled}
                            filter={filter}
                            id={`${id}-code`}
                            insideTable={false}
                            label={labelCode}
                            name={nameCode}
                            onChange={onChange}
                            optionLabel={'label'}
                            // optionValue={optionValue}
                            options={telephoneCodeOptions}
                            placeholder={placeholder}
                            publicMode={publicMode}
                            showClear={showClear}
                            showLabel={showLabel}
                            stateField={stateField}
                            validator={validator}
                            validators={`${required ? 'required' : 'not_required'}`}
                            value={phoneCodeValue}
                            viewMode={viewMode}
                            validateViewMode={validateViewMode}
                            renderRequired={renderRequired}
                            onAfterStateChange={() => {
                                this.setState({selectedCode: phoneCodeValue});
                                if (onAfterStateChange) {
                                    onAfterStateChange();
                                }
                            }}
                        />
                        <InputTextComponent
                            id={`${id}-text`}
                            name={namePhoneNumber}
                            label={labelPhoneNumber}
                            colClass={inputTextColClass}
                            insideTable={false}
                            showLabel={showLabel}
                            value={phoneNumberValue}
                            viewMode={viewMode}
                            onChange={onChange}
                            max={15}
                            validators={`${required ? 'required' : 'not_required'}|numeric${
                                phoneCodeValue !== undefined
                                    ? `|min:${phoneCodeValue.minDigits}|max:${phoneCodeValue.maxDigits}`
                                    : '|min:9|max:9'
                            }`}
                            validator={validator}
                            renderRequired={renderRequired}
                            disabled={disabled || phoneCodeValue === undefined}
                            keyfilter={/^[0-9]*$/i}
                            stateField={stateField}
                        />
                    </DivContainer>
                </DivContainer>
            );
        } else {
            return null;
        }
    }
}

PhoneNumberComponent.defaultProps = {
    colClass: 'col-xl-4 col-lg-6 col-md-6 col-sm-12',
    disabled: false,
    filter: false,
    filterBy: 'label',
    insideTable: false,
    placeholder: 'Wybierz',
    publicMode: false,
    rendered: true,
    showClear: false,
    showLabel: true,
    stateField: 'element',
    validateViewMode: false,
    validators: 'required',
    viewMode: 'VIEW',
    inputTextColClass: 'col-6'
};

PhoneNumberComponent.propTypes = {
    colClass: PropTypes.string,
    dataKey: PropTypes.string,
    disabled: PropTypes.bool,
    filter: PropTypes.bool,
    filterBy: PropTypes.string,
    id: PropTypes.string.isRequired,
    labelCode: PropTypes.string.isRequired,
    labelPhoneNumber: PropTypes.string.isRequired,
    nameCode: PropTypes.string.isRequired,
    namePhoneNumber: PropTypes.string.isRequired,
    onAfterStateChange: PropTypes.func,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    rendered: PropTypes.bool,
    showClear: PropTypes.bool,
    showLabel: PropTypes.bool,
    stateField: PropTypes.string,
    validateViewMode: PropTypes.bool,
    validator: PropTypes.object,
    validators: PropTypes.string,
    phoneCodeValue: PropTypes.object,
    phoneNumberValue: PropTypes.object,
    viewMode: PropTypes.string,
    inputTextColClass: PropTypes.string,
};

export default withTranslation()(PhoneNumberComponent);
